import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import WbButton from '../../../components/common/WbButton';
import WbLoader from '../../../components/common/WbLoader';
import KioskLayout from '../../../components/kiosk/KioskLayout';
import { useKiosk } from '../../../contexts/KioskContext';
import paths from '../../../routes/paths';
import '../KioskStyles.scss';
import {iconStartSurvey } from '../../../components/assets/images';

export default function ParentWelcome() {
  const { schoolSlug } = useParams();
  const { school, loading } = useKiosk();
  const navigate = useNavigate();

  if (loading) {
    return (
      <KioskLayout>
        <WbLoader />
      </KioskLayout>
    );
  }

  const schoolName = school?.schoolName || 'School';

  return (
    <KioskLayout>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Box className="kiosk-card" sx={{ textAlign: 'center' }}>
          <div className="kiosk-title">
            {schoolName}'s Survey Portal
          </div>
          <div className="kiosk-subtitle">
            Click here to start the survey
          </div>

          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            <WbButton
              CustomButtonText="Start Survey"
              onClick={() => navigate(paths.kioskParentSearch.replace(':schoolSlug', schoolSlug))}
              className="kiosk-button-secondary"  
              startIcon={<img src={iconStartSurvey} alt="Start Survey" />}
            />
          </Box>
        </Box>
      </Container>
    </KioskLayout>
  );
}
